module.exports = __webpack_public_path__ + "img/WY.370cef6d.png";